export default __webpack_public_path__ + "static/lab-ecar-d915fd00aa5312e676acfa7c0c4fc6e1.jpg";